import '../../styles/theme.scss'
import '../../styles/theme.scss.liquid'

import Vue from 'vue';
import * as moment from 'moment';
import 'moment-timezone';
window.moment = moment
import objectFitImages from 'object-fit-images'

import '../templates/products'
import '../templates/login'
import '../templates/cart'

import '../snippets/accordions'
import '../snippets/helpers'

import '../sections/header'
import '../sections/collections-list'
import '../sections/featured-products'

import '../snippets/product-card'

window.$ = window.jQuery = require("jquery");